import { Link } from 'react-router-dom'
import { CHANGELOG } from '../data/changelog'
import { formatCalendarDate } from '../components/ui'
import './Changelog.css'

/**
 * Dated history of what shipped on the site, newest first.
 */
export default function Changelog() {
  return (
    <div className="stack">
      <header className="page-header">
        <div>
          <span className="eyebrow">Changelog</span>
          <h1>What shipped</h1>
          <p>
            Each date is a production deploy of the website — new pages, admin tools, and
            the features behind a season. League news still lives on{' '}
            <Link className="player__name--link" to="/updates">
              Updates
            </Link>
            .
          </p>
        </div>
      </header>

      <ol className="changelog">
        {CHANGELOG.map(release => (
          <li key={release.version}>
            <article className="changelog__release">
              <div className="changelog__meta">
                <span className="changelog__version">{release.version}</span>
                <time className="changelog__date" dateTime={release.releasedOn}>
                  {formatCalendarDate(release.releasedOn)}
                </time>
              </div>
              <div className="changelog__body">
                <h2 className="changelog__title">{release.title}</h2>
                <ul className="changelog__changes">
                  {release.changes.map(change => (
                    <li key={change}>{change}</li>
                  ))}
                </ul>
              </div>
            </article>
          </li>
        ))}
      </ol>
    </div>
  )
}
